import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchReferralTransfer = () => {
  return useMutation({
    mutationFn: (data: any) => api.referral.fetchTransfer(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось получить список реферальных переводов',
        type: 'error',
      })
    }
  })
}
